// npm
import {
  CalendarIcon,
  ChartBarIcon,
  FolderIcon,
  HomeIcon,
  InboxIcon,
  UsersIcon,
  XIcon,
} from '@heroicons/react/outline'

export const menu = [
  { name: 'Dashboard', href: '/', icon: HomeIcon, current: true },
  { name: 'URLs', href: '/url/', icon: UsersIcon, current: false },
  { name: 'Images', href: '/image/', icon: FolderIcon, current: false },
  { name: 'Texts', href: '/text/', icon: CalendarIcon, current: false },
  { name: 'Pages', href: '/page/', icon: InboxIcon, current: false },
  { name: 'Reports', href: '#', icon: ChartBarIcon, current: false },
  { name: 'Markdown Pages', href: '/markdown/', icon: CalendarIcon, current: false },
  { name: 'Test', href: '/test/', icon: XIcon, current: false },
]
